import styled from "styled-components";

export const FooterContainer = styled.div `
  background: #eef1fc;
  text-align: center;
  height: 5vh;
  justify-content: center;
  align-items: center;
`